import * as React from 'react';
import {
    Box,
    Grid,
    Button,
    TextField,
    Snackbar,
    Alert,
    Typography,
    FormControl,
    MenuItem,
    Card,
    CardContent,
    FormControlLabel,
    Checkbox,
    FormHelperText,
    Radio,
    RadioGroup,
    Paper,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Modal
} from '@mui/material';

import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';

import {
    Autocomplete,
} from '@mui/material';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export const AgreementDetailsComp = (props) => {

    return (
        <Box>

            {/* HEADER */}
            <Box mb={3}>
                <Typography
                    variant="h5"
                    sx={{
                        fontWeight: 700,
                        color: '#042740'
                    }}
                >
                    Agreement Details
                </Typography>

                <Typography
                    variant="body2"
                    color="text.secondary"
                >
                    Manage agreement details, company information, referral partner, fees, and signatures
                </Typography>
            </Box>

            {/* COMPANY INFORMATION */}
            <Card sx={{ mb: 3, borderRadius: 3 }}>
                <CardContent>

                    <Typography
                        variant="h6"
                        sx={{
                            mb: 3,
                            color: '#042740',
                            fontWeight: 600
                        }}
                    >
                        Company Information
                    </Typography>

                    <Grid container spacing={2}>

                        {/* Company Name */}
                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                label="Company Name"
                                value={
                                    props.FormData.txtCompanyName || ''
                                }
                                error={
                                    !!props.FormData.txtCompanyNameErr
                                }
                                onChange={(e) =>
                                    props.HandleInputs(
                                        e,
                                        'txtCompanyName'
                                    )
                                }
                                disabled
                            />

                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {
                                    props.FormData.txtCompanyNameErr
                                }
                            </FormHelperText>
                        </Grid>


                        {/* Representative Name */}
                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                label="Representative Name"
                                value={
                                    props.FormData
                                        .txtCompanyRepresentativeName || ''
                                }
                                error={
                                    !!props.FormData
                                        .txtCompanyRepresentativeNameErr
                                }
                                onChange={(e) =>
                                    props.HandleInputs(
                                        e,
                                        'txtCompanyRepresentativeName'
                                    )
                                }
                                disabled
                            />

                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {
                                    props.FormData
                                        .txtCompanyRepresentativeNameErr
                                }
                            </FormHelperText>
                        </Grid>


                        {/* Representative Email */}
                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                type="email"
                                label="Representative Email"
                                value={
                                    props.FormData
                                        .txtCompanyRepresentativeEmail || ''
                                }
                                error={
                                    !!props.FormData
                                        .txtCompanyRepresentativeEmailErr
                                }
                                onChange={(e) =>
                                    props.HandleInputs(
                                        e,
                                        'txtCompanyRepresentativeEmail'
                                    )
                                }
                                disabled
                            />

                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {
                                    props.FormData
                                        .txtCompanyRepresentativeEmailErr
                                }
                            </FormHelperText>
                        </Grid>


                        {/* Representative Designation */}
                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                label="Representative Designation"
                                value={
                                    props.FormData
                                        .txtCompanyRepresentativeDesignation || ''
                                }
                                error={
                                    !!props.FormData
                                        .txtCompanyRepresentativeDesignationErr
                                }
                                onChange={(e) =>
                                    props.HandleInputs(
                                        e,
                                        'txtCompanyRepresentativeDesignation'
                                    )
                                }
                                disabled
                            />

                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {
                                    props.FormData
                                        .txtCompanyRepresentativeDesignationErr
                                }
                            </FormHelperText>
                        </Grid>


                        {/* Company Address */}
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Company Address"
                                value={
                                    props.FormData.txtCompanyAddress || ''
                                }
                                error={
                                    !!props.FormData.txtCompanyAddressErr
                                }
                                onChange={(e) =>
                                    props.HandleInputs(
                                        e,
                                        'txtCompanyAddress'
                                    )
                                }
                                disabled
                            />

                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {
                                    props.FormData.txtCompanyAddressErr
                                }
                            </FormHelperText>
                        </Grid>




                    </Grid>

                </CardContent>
            </Card>



            {/* REFERRAL PARTNER INFORMATION */}
            <Card sx={{ mb: 3, borderRadius: 3 }}>
                <CardContent>

                    <Typography
                        variant="h6"
                        sx={{
                            mb: 3,
                            color: '#042740',
                            fontWeight: 600
                        }}
                    >
                        Referral Partner Information
                    </Typography>

                    <Grid container spacing={2}>

                        {/* Referral Partner / Company Name */}
                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                label="Referral Partner / Company Name"
                                value={
                                    props.FormData
                                        .txtReferralPartnerCompanyName || ''
                                }
                                error={
                                    !!props.FormData
                                        .txtReferralPartnerCompanyNameErr
                                }
                                onChange={(e) =>
                                    props.HandleInputs(
                                        e,
                                        'txtReferralPartnerCompanyName'
                                    )
                                }
                            />

                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {
                                    props.FormData
                                        .txtReferralPartnerCompanyNameErr
                                }
                            </FormHelperText>
                        </Grid>

                        {/* Representative Name */}
                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                label="Representative Name"
                                value={
                                    props.FormData
                                        .txtReferralPartnerRepresentativeName || ''
                                }
                                error={
                                    !!props.FormData
                                        .txtReferralPartnerRepresentativeNameErr
                                }
                                onChange={(e) =>
                                    props.HandleInputs(
                                        e,
                                        'txtReferralPartnerRepresentativeName'
                                    )
                                }
                            />

                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {
                                    props.FormData
                                        .txtReferralPartnerRepresentativeNameErr
                                }
                            </FormHelperText>
                        </Grid>


                        {/* Representative Email */}
                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                type="email"
                                label="Representative Email"
                                value={
                                    props.FormData
                                        .txtReferralPartnerRepresentativeEmail || ''
                                }
                                error={
                                    !!props.FormData
                                        .txtReferralPartnerRepresentativeEmailErr
                                }
                                onChange={(e) =>
                                    props.HandleInputs(
                                        e,
                                        'txtReferralPartnerRepresentativeEmail'
                                    )
                                }
                            />

                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {
                                    props.FormData
                                        .txtReferralPartnerRepresentativeEmailErr
                                }
                            </FormHelperText>
                        </Grid>


                        {/* Representative Designation */}
                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                label="Representative Designation"
                                value={
                                    props.FormData
                                        .txtReferralPartnerRepresentativeDesignation || ''
                                }
                                error={
                                    !!props.FormData
                                        .txtReferralPartnerRepresentativeDesignationErr
                                }
                                onChange={(e) =>
                                    props.HandleInputs(
                                        e,
                                        'txtReferralPartnerRepresentativeDesignation'
                                    )
                                }
                            />

                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {
                                    props.FormData
                                        .txtReferralPartnerRepresentativeDesignationErr
                                }
                            </FormHelperText>
                        </Grid>


                        {/* Office Address */}
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Office Address"
                                value={
                                    props.FormData
                                        .txtReferralPartnerOfficeAddress || ''
                                }
                                error={
                                    !!props.FormData
                                        .txtReferralPartnerOfficeAddressErr
                                }
                                onChange={(e) =>
                                    props.HandleInputs(
                                        e,
                                        'txtReferralPartnerOfficeAddress'
                                    )
                                }
                            />

                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {
                                    props.FormData
                                        .txtReferralPartnerOfficeAddressErr
                                }
                            </FormHelperText>
                        </Grid>




                    </Grid>

                </CardContent>
            </Card>



            {/* AGREEMENT INFORMATION */}
            <Card sx={{ mb: 3, borderRadius: 3 }}>
                <CardContent>

                    <Typography
                        variant="h6"
                        sx={{
                            mb: 3,
                            color: '#042740',
                            fontWeight: 600
                        }}
                    >
                        Agreement Information
                    </Typography>

                    <Grid container spacing={2}>

                        {/* Date */}
                        <Grid item xs={12} md={4}>
                            <TextField
                                type="date"
                                fullWidth
                                InputLabelProps={{
                                    shrink: true
                                }}
                                label="Date"
                                value={
                                    props.FormData.txtDate || ''
                                }
                                error={
                                    !!props.FormData.txtDateErr
                                }
                                onChange={(e) =>
                                    props.HandleInputs(
                                        e,
                                        'txtDate'
                                    )
                                }
                            />

                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {
                                    props.FormData.txtDateErr
                                }
                            </FormHelperText>
                        </Grid>


                     


                        {/* Referral Fee */}
                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="Referral Fee (Rs.)"
                                value={
                                    props.FormData.txtReferralFee || ''
                                }
                                error={
                                    !!props.FormData.txtReferralFeeErr
                                }
                                onChange={(e) =>
                                    props.HandleInputs(
                                        e,
                                        'txtReferralFee'
                                    )
                                }
                                disabled
                            />

                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {
                                    props.FormData.txtReferralFeeErr
                                }
                            </FormHelperText>
                        </Grid>

                    </Grid>

                </CardContent>
            </Card>





            {/* SAVE BUTTON */}
            < Grid container >
                <Grid item xs={12}>
                    <Box textAlign={'center'} m={3}>

                        {
                            props.mystate.mode === 'add' ?

                                props.FormData.addUser === true ?

                                    <LoadingButton
                                        loading
                                        loadingPosition="start"
                                        startIcon={<SaveIcon />}
                                        variant="contained"
                                    >
                                        Save Agreement
                                    </LoadingButton>

                                    :

                                    <Button
                                        variant="contained"
                                        className='grey-theme-btn'
                                        onClick={() => props.SaveOrUpdateAgreement()}
                                    >
                                        Save Agreement
                                    </Button>

                                :

                                props.FormData.editUser === true ?

                                    <LoadingButton
                                        loading
                                        loadingPosition="start"
                                        startIcon={<SaveIcon />}
                                        variant="contained"
                                    >
                                        Update Agreement
                                    </LoadingButton>

                                    :

                                    <Button
                                        variant="contained"
                                        className='grey-theme-btn'
                                        onClick={() => props.SaveOrUpdateAgreement()}
                                    >
                                        Update Agreement
                                    </Button>
                        }

                    </Box>
                </Grid>
            </Grid >

            {/* ALERT */}
            < Snackbar
                open={props.mystate.showAlert}
                autoHideDuration={3000}
                onClose={() => {
                    props.HandleCloseAlertMsg(props.mystate.alertType);
                }}
            >
                <Alert
                    onClose={() => {
                        props.HandleCloseAlertMsg(props.mystate.alertType);
                    }}
                    severity={props.mystate.alertType}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {props.mystate.alertMsg}
                </Alert>
            </Snackbar >

        </Box >
    );
};